import { AoInstance } from "./ao"
import ENV from "../env"

export default async function getUserLockedTokens(
  userAddress: string,
  tokenId: string,
  ao: AoInstance,
) {
  const tags = [
    { name: "Action", value: "User-Locked-Tokens" },
    { name: "Token", value: tokenId },
    { name: "User", value: userAddress as string },
  ]

  try {
    const result = await ao.dryrun({
      process: ENV.VITE_TOKEN_LOCKER_PROCESS,
      tags,
    })

    if (result.Messages.length === 0) throw new Error("No response from Locked-Tokens")

    const data = result.Messages[0].Data

    if (!data) throw new Error("Response malformed")

    const tokenDetails = JSON.parse(data) as {
      Amount: string
      Period: string
      Start: string
      End: string
    }[]

    return tokenDetails[0]
  } catch (error) {
    return null
  }
}
